export class UserRow {
    constructor(userInfo?: any) {
        for (let key in userInfo) {
            switch (key.toLowerCase()) {
                case "email": this.Email = userInfo[key]; break;
                case "firstname": this.FirstName = userInfo[key]; break;
                case "lastname": this.LastName = userInfo[key]; break;
                case "permission": this.Permission = userInfo[key]; break;
                case "id": this.id = userInfo[key]; break;
                case "cb": this.cb = userInfo[key]; break;
                default: this.cb = false; break;
            }
        }
    }
    Email: string;
    FirstName: string;
    LastName: string;
    Permission: number;
    Access: string;
    id: number;
    cb: boolean;
}

export class PermissionsUserRow {
    constructor(userInfo?: any) {
        for (let key in userInfo) {
            switch (key.toLowerCase()) {
                case "username": this.username = userInfo[key]; break;
                case "fname": this.fName = userInfo[key]; break;
                case "lname": this.lName = userInfo[key]; break;
                case "id": this.id = userInfo[key]; break;
                case "logincount": this.loginCount = userInfo[key]; break;
                case "ramsuserid": this.ramsUserId = userInfo[key]; break;
                case "role": this.role = userInfo[key]; break;
                default: this.cb = false; break;
            }
        }
    }
    cb: boolean;
    fName: string;
    id: string;
    lName: string;
    loginCount: number;
    ramsUserId: number;
    username: string;
    role: string;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./App/Classes/GridRows.ts